// @flow
import $ from 'jquery';
import 'fg-frontend/plugins/required/jquery.cookies-policy';

/**
 * JS oznámení o použití cookies na webu
 * default nastavení - viz: fg-frontend/plugins/required/jquery.cookies-policy
 *
 * * možnost redefinovat si styly přidáním parametru přes parametr css, případně je barvu tlačítka a odkazu: css.brandColor
 * * position - určuje vložení do požadovaného elementu na začátek (position: 'top') nebo na konec (position: 'bottom'),
 * * možnost definovat si vlastní textaci přes parametr messages.lang: (defaulty jsou v CS, SK, EN, DE, RU, ES)
 */
export default (): void => {
	$('body').cookiesPolicy({
		lang: window.projectConfig.lang,
		messages: {
			'sk': {
				link: '/sk/ochrana-osobnych-udajov'
			}
		},
		css: {
			brandColor: '#9287AD',
			panel: {
				'text-align': 'left',
				'color': '#26105B',
				'background-color': '#F4F3F7',
				'font-size': '11px',
				'line-height': '18px'
			}
		}
	});
};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/CookiesPolicy.js